/**
	Bind multiple component methods:

	* @param {this} context
	* @param {Array} functions

	constructor() {
		...
		bindFunctions.call(this, ['handleClick', 'handleOther']);
	}
*/

"use strict";

module.exports = function bindFunctions(functions) {
	var _this = this;

	functions.forEach(function (f) {
		return _this[f] = _this[f].bind(_this);
	});
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-images/lib/utils/bindFunctions.js
 ** module id = 303
 ** module chunks = 0
 **/